// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Bundle from "./bundle.js"
import Tenant from "./tenant.js"
import TenantPhotoProduct from "./tenant-photo-product.js"

const modelClassData = {
  "attributes": {
    "bundle_id": {
      "column": {
        "default": null,
        "name": "bundle_id",
        "null": false,
        "type": "uuid"
      },
      "name": "bundle_id",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "tenant_id": {
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      },
      "name": "tenant_id",
      "selected_by_default": null,
      "translated": null
    },
    "tenant_photo_product_id": {
      "column": {
        "default": null,
        "name": "tenant_photo_product_id",
        "null": true,
        "type": "uuid"
      },
      "name": "tenant_photo_product_id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "BundleTenantPhotoProduct",
  "collectionKey": "bundle_tenant_photo_products",
  "collectionName": "bundle_tenant_photo_products",
  "i18nKey": "bundle_tenant_photo_product",
  "camelizedLower": "bundleTenantPhotoProduct",
  "name": "BundleTenantPhotoProduct",
  "nameDasherized": "bundle-tenant-photo-product",
  "pluralName": "bundle_tenant_photo_products",
  "ransackable_associations": [
    {
      "className": "Bundle",
      "collectionName": "bundles",
      "foreignKey": "bundle_id",
      "name": "bundle",
      "macro": "belongs_to",
      "resource_name": "Bundle",
      "through": null
    },
    {
      "className": "BundleOrderLineElement",
      "collectionName": "bundle_order_line_elements",
      "foreignKey": "bundle_tenant_photo_product_id",
      "name": "bundle_order_line_elements",
      "macro": "has_many",
      "resource_name": "BundleOrderLineElement",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "PhotoProduct",
      "collectionName": "photo_products",
      "foreignKey": "photo_product_id",
      "name": "photo_product",
      "macro": "has_one",
      "resource_name": "PhotoProduct",
      "through": "tenant_photo_product"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "TenantPhotoProduct",
      "collectionName": "tenant_photo_products",
      "foreignKey": "tenant_photo_product_id",
      "name": "tenant_photo_product",
      "macro": "belongs_to",
      "resource_name": "TenantPhotoProduct",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "bundle_id",
      "column": {
        "default": null,
        "name": "bundle_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_photo_product_id",
      "column": {
        "default": null,
        "name": "tenant_photo_product_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Bundle",
      "collectionName": "bundles",
      "foreignKey": "bundle_id",
      "name": "bundle",
      "macro": "belongs_to",
      "resource_name": "Bundle",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "TenantPhotoProduct",
      "collectionName": "tenant_photo_products",
      "foreignKey": "tenant_photo_product_id",
      "name": "tenant_photo_product",
      "macro": "belongs_to",
      "resource_name": "TenantPhotoProduct",
      "through": null
    }
  ],
  "paramKey": "bundle_tenant_photo_product",
  "primaryKey": "id"
}

/** Frontend model for BundleTenantPhotoProduct. */
export default class BundleTenantPhotoProduct extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  bundleId() {
    return this.readAttributeUnderscore("bundle_id")
  }

  /** @returns {boolean} */
  hasBundleId() {
    const value = this.bundleId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  tenantId() {
    return this.readAttributeUnderscore("tenant_id")
  }

  /** @returns {boolean} */
  hasTenantId() {
    const value = this.tenantId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  tenantPhotoProductId() {
    return this.readAttributeUnderscore("tenant_photo_product_id")
  }

  /** @returns {boolean} */
  hasTenantPhotoProductId() {
    const value = this.tenantPhotoProductId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("./bundle.js").default | null} */
  bundle() {
    return this._readBelongsToReflection({modelClass: Bundle, reflectionName: "bundle"})
  }

  /** @returns {Promise<import("./bundle.js").default | null>} */
  loadBundle() {
    if (!("bundleId" in this)) throw new Error("Foreign key method wasn't defined: bundleId")

    const id = this.bundleId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "bundle",
        model: this,
        modelClass: Bundle
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./bundle.js").default | null>} */
  ensureBundleLoaded() {
    return this.ensureAssociationLoaded("bundle")
  }

  /** @returns {import("./tenant.js").default | null} */
  tenant() {
    return this._readBelongsToReflection({modelClass: Tenant, reflectionName: "tenant"})
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  loadTenant() {
    if (!("tenantId" in this)) throw new Error("Foreign key method wasn't defined: tenantId")

    const id = this.tenantId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "tenant",
        model: this,
        modelClass: Tenant
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  ensureTenantLoaded() {
    return this.ensureAssociationLoaded("tenant")
  }

  /** @returns {import("./tenant-photo-product.js").default | null} */
  tenantPhotoProduct() {
    return this._readBelongsToReflection({modelClass: TenantPhotoProduct, reflectionName: "tenant_photo_product"})
  }

  /** @returns {Promise<import("./tenant-photo-product.js").default | null>} */
  loadTenantPhotoProduct() {
    if (!("tenantPhotoProductId" in this)) throw new Error("Foreign key method wasn't defined: tenantPhotoProductId")

    const id = this.tenantPhotoProductId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "tenant_photo_product",
        model: this,
        modelClass: TenantPhotoProduct
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant-photo-product.js").default | null>} */
  ensureTenantPhotoProductLoaded() {
    return this.ensureAssociationLoaded("tenant_photo_product")
  }
}
